<template>
  <span class="rangesection">
    <label :for="itemId">{{label}}</label>
    <span class="rangewrap">
      <input v-model="currentItem.amount" type="range" :min="min" :max="max" :step="step" class="slider swiper-no-swiping" :id="itemId" :disabled="itemDisabled">
    </span>
    <input class="number swiper-no-swiping" :class="cssWidth" v-model="currentItem.amount" type="number" :max="max" size="3" />
    <!-- <span class="number">{{currentItem.amount}}</span> -->
  </span>
</template>

<script>
export default {
  name: 'Rangeslider',
  props: {
    min: Number,
    max: Number,
    start: Number,
    itemId: String,
    label: String,
    itemDisabled: {
      type: Boolean,
      default: false,
      required: false
    },
    step: {
      type: Number,
      default: 1
    },
    single: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getItemByID: function (itemId) {
      return this.$root.getItemByID(itemId)
    }
  },
  computed: {
    currentItem: function () {
      return this.getItemByID(this.itemId)
    },
    currentItemAmount: function () {
      return this.currentItem.amount
    },
    outputNumber: function () {
      if (this.currentItem.amount < 1) {
        return 0
      } else {
        return this.currentItem.amount
      }
    },
    cssWidth: function () {
      if (this.max < 10) {
        return 'width-1'
      } else if (this.max < 100) {
        return 'width-2'
      } else if (this.max < 1000) {
        return 'width-3'
      } else {
        return 'width-4'
      }
    }
    /*,
    activeRange: function () {
      return (parseFloat(this.outputNumber) - 1) / parseFloat(this.max) * 100
    },
    pxToSubstract: function () {
      return this.activeRange
    },
    styles: function () {
      return {
        'width': 'calc(' + this.activeRange + '% + ' + this.pxToSubstract + 'px)'
        // 'width': 'calc(' + this.activeRange + '%)'
      }
    }
    */
  },
  watch: {
    currentItemAmount: function (amount) {
      if (this.single) {
        if (amount > 0) {
          this.currentItem.status = true
        } else {
          this.currentItem.status = false
        }
      }
      if (amount > this.max) {
        this.currentItem.amount = this.max
      }
      if (!/^\d+$/.test(amount)) { // input is not a number
        this.currentItem.amount = 0
      }
      if (amount.length === 2 && amount.charAt(0) === '0') {
        this.currentItem.amount = this.currentItem.amount.substr(1)
      }
    }
  }
  /*,
  watch: {
    currentItemAmount: function (amount) {
      if (amount > 0) {
        this.currentItem.status = true
      } else {
        this.currentItem.status = false
      }
    }
  }
  */
}
</script>

<style scoped lang="scss">
@import "../assets/css/variables.scss";

.rangesection {
  width:100%;
  display: flex;
  align-items: center;
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
  }
  .number {
    margin-left: 9px;
    font-family: $secondaryFont;
    font-size: 18px;
    width: auto;
    -webkit-appearance: none;
    -moz-appearance: textfield;
    -ms-appearance: none;
    -o-appearance: none;
    appearance: none;
    outline: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    box-sizing: border-box;
    padding: 0;
    border:none;
    outline: 0;
    &:hover {
      cursor: pointer;
    }
  }
  .width-1 {
    width: 11px;
  }
  .width-2 {
    width: 22px;
  }
  .width-3 {
    width: 33px;
  }
  .width-4 {
    width: 43px;
  }
  /*
  .number {
    margin-left: 9px;
    font-family: $secondaryFont;
    font-size: 18px;
    -webkit-appearance: textfield;
    -moz-appearance: textfield;
    appearance: textfield;
    background: none;
    background: transparent;
    border:none;
    outline: none;
    width:35px;
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
  */
  .rangewrap {
    display: flex;
    position: relative;
    width: 100%;
    .active {
      left: 0;
      top:50%;
      transform: translateY(-3px);
      height: 7px;
      // background-color: $primaryColor;
      background-color: red;
      display: block;
      z-index: 2;
      position: absolute;
      border-top-left-radius: 3.5px;
      border-bottom-left-radius: 3.5px;
      display: none;
    }
  }
}
label {
  margin: 0;
  font-family: $secondaryFont;
  font-size: 18px;
  margin-right: 8px;
}
// Styling Cross-Browser Compatible Range Inputs with Sass
// Github: https://github.com/darlanrod/input-range-sass
// Author: Darlan Rod https://github.com/darlanrod
// Version 1.5.2
// MIT License

$track-color: #9BAFFF !default;
$thumb-color: $primaryColor !default;

$thumb-radius: 15px !default;
$thumb-height: 30px !default;
$thumb-width: 30px !default;
$thumb-shadow-size: 4px !default;
$thumb-shadow-blur: 4px !default;
$thumb-shadow-color: rgba(0, 0, 0, 0.06) !default;
$thumb-border-width: 1px !default;
$thumb-border-color: #5174FF !default;

$track-width: 100% !default;
$track-height: 6px !default;
$track-shadow-size: 1px !default;
$track-shadow-blur: 1px !default;
$track-shadow-color: rgba(0, 0, 0, 0.06) !default;
$track-border-width: 1px !default;
$track-border-color: #99AEFF !default;

$track-radius: 5px !default;
$contrast: 5% !default;

$ie-bottom-track-color: darken($track-color, $contrast) !default;

@mixin shadow($shadow-size, $shadow-blur, $shadow-color) {
  box-shadow: $shadow-size $shadow-size $shadow-blur $shadow-color, 0 0 $shadow-size lighten($shadow-color, 5%);
}

@mixin track {
  cursor: pointer;
  height: $track-height;
  transition: all .2s ease;
  width: $track-width;
  z-index: 1;
}

@mixin thumb {
  @include shadow($thumb-shadow-size, $thumb-shadow-blur, $thumb-shadow-color);
  background: $thumb-color;
  border: $thumb-border-width solid $thumb-border-color;
  border-radius: $thumb-radius;
  box-sizing: border-box;
  cursor: pointer;
  height: $thumb-height;
  width: $thumb-width;
}

[type='range'] {
  position: relative;
  -webkit-appearance: none;
  background: transparent;
  margin: $thumb-height / 2 0;
  width: $track-width;
  margin: 0;
  padding: 0;

  &::-moz-focus-outer {
    border: 0;
  }

  &:focus {
    outline: 0;

    &::-webkit-slider-runnable-track {
      background: lighten($track-color, $contrast);
    }

    &::-ms-fill-lower {
      background: $track-color;
    }

    &::-ms-fill-upper {
      background: lighten($track-color, $contrast);
    }
  }

  &::-webkit-slider-runnable-track {
    @include track;
    // @include shadow($track-shadow-size, $track-shadow-blur, $track-shadow-color);
    background: $track-color;
    border: $track-border-width solid $track-border-color;
    border-radius: $track-radius;
  }

  &::-webkit-slider-thumb {
    @include thumb;
    -webkit-appearance: none;
    margin-top: ((-$track-border-width * 2 + $track-height) / 2 - $thumb-height / 2);
  }

  &::-moz-range-track {
    // @include shadow($track-shadow-size, $track-shadow-blur, $track-shadow-color);
    @include track;
    background: $track-color;
    border: $track-border-width solid $track-border-color;
    border-radius: $track-radius;
    height: $track-height / 2;
  }

  &::-moz-range-thumb {
    @include thumb;
  }

  &::-ms-track {
    @include track;
    background: transparent;
    border-color: transparent;
    border-width: ($thumb-height / 2) 0;
    color: transparent;
  }

  &::-ms-fill-lower {
    // @include shadow($track-shadow-size, $track-shadow-blur, $track-shadow-color);
    background: $ie-bottom-track-color;
    border: $track-border-width solid $track-border-color;
    border-radius: ($track-radius * 2);
  }

  &::-ms-fill-upper {
    // @include shadow($track-shadow-size, $track-shadow-blur, $track-shadow-color);
    background: $track-color;
    border: $track-border-width solid $track-border-color;
    border-radius: ($track-radius * 2);
  }

  &::-ms-thumb {
    @include thumb;
    margin-top: $track-height / 4;
  }

  &:disabled {
    &::-webkit-slider-thumb,
    &::-moz-range-thumb,
    &::-ms-thumb,
    &::-webkit-slider-runnable-track,
    &::-ms-fill-lower,
    &::-ms-fill-upper {
      cursor: not-allowed!important;
    }
  }
}

</style>
